<template>
     <div class="bg">
         <div class="title">
             <h2>劳务协议基本信息</h2>
         </div>
         <div class="item">
             <span>姓名</span>
             <input type="text" placeholder="请输入姓名" v-model="info.name">
         </div>
         <div class="item">
             <span>身份证号</span>
             <input type="text" placeholder="请输入身份证号" v-model="info.id">
         </div>
         <div class="item">
             <span>开户行</span>
             <input type="text" placeholder="请输入开户行" v-model="info.bank">
         </div>
         <div class="item">
             <span>银行账号</span>
             <input type="text" placeholder="请输入银行账号" v-model="info.account">
         </div>
         <div class="item">
             <span>手机号</span>
             <input type="text" placeholder="请输入手机号" v-model="info.phone">
         </div>
         <div class="submit" @click="toSubmit">
             <span>{{submitInfo}}</span>
         </div>
     </div>
</template>

<script>
    import {agreementBaseInfo,editInfo} from "@/assets/js/api";
    // pdf预览
    export default {
        name: "Home",
        components: {
        },
        data() {
            return {
                agreementId:this.$route.query.id,
                submitInfo:"提交",
                info:{
                    name:null,
                    id:null,
                    bank:null,
                    account:null,
                    phone:null,
                }
            };
        },
        mounted() {
            this.getBaseInfo(this.agreementId)
        },
        methods: {
            async getBaseInfo(agreementId){
                const res = await agreementBaseInfo({agreementId})
                this.info.name = res.data.data.name
                this.info.id = res.data.data.id
                this.info.account = res.data.data.account
                this.info.bank = res.data.data.bank
                this.info.phone = res.data.data.phone
                console.log(res)
            },
            toSubmit(){

                console.log(this.info,"info")

                if(this.info.name==null||this.info.id==null||this.info.bank==null||this.info.account==null||this.info.phone==null){
                    this.$toast("请完善基本信息");
                    return
                }
                if(this.info.name==""||this.info.id==""||this.info.bank==""||this.info.account==""||this.info.phone==""){
                    this.$toast("请完善基本信息");
                    return
                }

                this.submit(this.agreementId,this.info.name,this.info.id,this.info.bank,this.info.account,this.info.phone)
            },
            async submit(agreementId,name,id,bank,account,phone){
                const  res = await editInfo({agreementId,name,id,bank,account,phone})
                if(res.data.success){
                    this.$router.go(-1);
                }else{
                    this.$toast(res.data.message)
                }
            }
        }
    };
</script>

<style scoped lang="scss">
    .bg{
        width: 100%;
        height: 100vh;
        display: flex;
        flex-direction: column;
        background: #FFF;
    }
    .title{
        margin-top: 50px;
        margin-bottom: 30px;
    }
    .bg .item{
        width: 80%;
        text-align: center;
        display: flex;
        justify-content: center;
        flex-flow: row nowrap;
        font-size: 15px;
        margin: 0 auto;
    }
    .bg .item span{
        margin: 10px;
        width: 30%;
        text-align: center;
        font-weight: bold;
    }
    .bg .item input{
        border: none;
        outline: none;
        border-bottom: 1px solid #156098;
        width: 70%;
        text-indent: 5px;
        font-size: 14px;
        margin: 0;
        padding: 0;
    }
    .submit{
        margin: 30px auto;
        font-size: 18px;
        background: #156098;
        width: 70%;
        border-radius: 20px;
        color: #FFF;
        padding: 5px 0;
    }
    input::-webkit-input-placeholder {
    }

</style>
